import { APIService } from './ApiService';

export const getAccessCodes = () => APIService.get('users/accesscodes/all');

export const addAccessCode = payload => APIService.post('users/accesscodes', { ...payload });
